import { render, staticRenderFns } from "./ActivityBuilder.vue?vue&type=template&id=27e67648&scoped=true"
import script from "./ActivityBuilder.vue?vue&type=script&lang=ts"
export * from "./ActivityBuilder.vue?vue&type=script&lang=ts"
import style0 from "./ActivityBuilder.vue?vue&type=style&index=0&id=27e67648&prod&lang=scss"
import style1 from "./ActivityBuilder.vue?vue&type=style&index=1&id=27e67648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e67648",
  null
  
)

export default component.exports